<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2"
  >
    <div class="flex items-center justify-center">
      <img src="@/assets/home.png" alt="" class="w-1/2" />
    </div>

    <div class="mt-16">
      <h1 class="font-sedgwick text-3xl text-center text-[#f8f7f2]">
        Gustavo Kubiack
      </h1>
      <p
        class="font-sans lg:text-lg sm:text-sm p-6 text-justify text-[#f8f7f2]"
      >
        Olá, me chamo Gustavo Kubiack e tenho 19 anos de idade. Sou
        Desenvolvedor Full-Stack, entusiasta em segurança da informação e
        apaixonado por tecnologia.
      </p>

      <div class="flex items-center justify-center">
        <Contato />
      </div>
    </div>
  </div>
</template>

<script>
import Contato from "@/components/Contatos.vue";
export default {
  name: "Home",
  components: {
    Contato,
  },
};
</script>

<style>
</style>